import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function PfeTileChartHelp() {
    return (
        <IconTooltip>
            <div>
                Polarized Fractal Efficiency (“PFE”) is an indication of the
                strength of either a bullish or bearish trend. <br /> <br />
                It ranges between −100 and +100. Zero (0) is neutral, meaning no
                conviction. The higher the PFE, the greater the strength of an
                upward trend. The lower the PFE, the greater the strength of a
                downward trend. As the PFE value moves away from zero, the
                conviction around strength and efficiency of a trend increases.
                A PFE value that fluctuates around the zero line may indicate
                that supply and demand are in relative balance and the price may
                continue to trade sideways. <br /> <br />
                The PFE Capsule can be configured by selecting a symbol from
                your portfolio or adding it into settings. Time period and
                lookback values can also be configured in the settings.
            </div>
        </IconTooltip>
    );
}
